"use client";

import type { SortOption } from "@/lib/catalog";

const SORT_LABELS: Record<SortOption, string> = {
  relevance: "Featured",
  "price-asc": "Price: low to high",
  "price-desc": "Price: high to low",
  newest: "Newest",
};

const fieldStyle: React.CSSProperties = {
  border: "1px solid var(--line-strong)",
  background: "var(--surface)",
  color: "var(--ink)",
};

// The one genuinely interactive control on an otherwise server-rendered,
// no-JS-required filter form — auto-submits the enclosing <form method="get">
// on change so picking a sort order doesn't require a separate click.
export default function SortSelect({ value, showPrice = true }: { value: SortOption; showPrice?: boolean }) {
  const options = (Object.keys(SORT_LABELS) as SortOption[]).filter((s) => showPrice || (s !== "price-asc" && s !== "price-desc"));
  return (
    <select
      name="sort"
      defaultValue={value}
      onChange={(e) => e.currentTarget.form?.requestSubmit()}
      className="rounded-md px-2 py-1.5 text-sm"
      style={fieldStyle}
    >
      {options.map((s) => (
        <option key={s} value={s}>
          {SORT_LABELS[s]}
        </option>
      ))}
    </select>
  );
}
